// extracted by mini-css-extract-plugin
export default {"container":"Lca-z","creativeContainer":"Mca-z","copy":"Nca-z","cta":"Oca-z","disabled":"Pca-z","flipped":"Qca-z","productCard":"Rca-z"};